<template>
    <common-modal :width="'medium'" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('pages.billing.billing.billing_address_modal.edit')"
                size="page-plain-header"
                contentSpacing="medium"
                :isCenter="true"
            ></common-page-header>
            <form-wrapper class="form__fields" :isSubmittable="false">
                <form-row>
                    <form-cell width="half">
                        <text-field
                            :label="$t('pages.billing.billing.billing_address_modal.address_label')"
                            :placeholder="$t('pages.billing.billing.billing_address_modal.address_placeholder')"
                            :isRequired="true"
                            :formData="data"
                            valuePath="address"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            :label="$t('pages.billing.billing.billing_address_modal.city_label')"
                            :placeholder="$t('pages.billing.billing.billing_address_modal.city_placeholder')"
                            :isRequired="true"
                            :formData="data"
                            valuePath="city"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        {{ data.state }}
                        <select-field
                            :label="$t('pages.billing.billing.billing_address_modal.state_label')"
                            :placeholder="$t('pages.billing.billing.billing_address_modal.state_placeholder')"
                            :isRequired="true"
                            :options="states"
                            :formData="data"
                            valuePath="state"
                            @change="change($event)"
                        ></select-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            :label="$t('pages.billing.billing.billing_address_modal.zip_label')"
                            :placeholder="$t('pages.billing.billing.billing_address_modal.zip_placeholder')"
                            :isRequired="true"
                            :formData="data"
                            valuePath="zip"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
            </form-wrapper>
            <common-buttons>
                <common-button
                    :label="$t('forms.auth.schedule.microcopy.save')"
                    class="auth-invite-admin-register-practice__button"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                    @click="saveBillingAddress"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import PracticesAPI from 'api/PracticesAPI'

    export default {
        mixins: [FormMixin],
        components: {},
        props: {
            states: { type: Array, required: true },
            billingAddress: { type: Object, default: undefined },
        },

        data() {
            return {
                isSending: false,
            }
        },

        computed: {},
        methods: {
            saveBillingAddress() {
                const request = {
                    billingAddress: {
                        address: this.data.address,
                        state: this.data.state,
                        zip: this.data.zip,
                        city: this.data.city,
                    },
                }
                PracticesAPI.saveBillingAddress(request).then(() => {
                    this.$emit('billing-address-saved', request)
                })
            },
        },

        mounted() {
            this.data.state = this.billingAddress.state
            this.data.city = this.billingAddress.city
            this.data.zip = this.billingAddress.zip
            this.data.address = this.billingAddress.address
        },
    }
</script>
